import { Component, Input } from '@angular/core';
import { UserInfoMember } from '../../models/user-info';
import { ContainerType } from '../../models/container.types';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
    standalone: false,
})
export class UserInfoComponent {
    @Input() userInfo: UserInfoMember;
    @Input() containerType: ContainerType;

    getDisplayName(): string {
        if (this.userInfo) {
            return this.userInfo.firstName && this.userInfo.lastName
                ? this.userInfo.firstName + ' ' + this.userInfo.lastName
                : this.userInfo.displayName;
        }
    }

    getTranslationKeyForRole(): string {
        if (this.userInfo && this.containerType) {
            const containerTypeKey: string =
                this.containerType === ContainerType.IMAGE_DB
                    ? 'imgDb'
                    : 'project';

            return `role.${containerTypeKey}.${this.userInfo.role}`;
        }
    }
}
